module.exports = __webpack_public_path__ + "assets/img/3.69e609c2.jpg";